export const zodiacSigns = {
  aquarius: 'Wassermann',
  pisces: 'Fisch',
  aries: 'Widder',
  taurus: 'Stier',
  gemini: 'Zwilling',
  cancer: 'Krebs',
  leo: 'Löwe',
  virgo: 'Jungfrau',
  libra: 'Waage',
  scorpio: 'Skorpion',
  sagittarius: 'Schütze',
  capricornus: 'Steinbock',
};

export function getZodiacSign(date: Date): string {
  const zodiacDates = {
    aquarius: [
      [1, 21],
      [2, 19],
    ],
    pisces: [
      [2, 20],
      [3, 20],
    ],
    aries: [
      [3, 21],
      [4, 20],
    ],
    taurus: [
      [4, 21],
      [5, 20],
    ],
    gemini: [
      [5, 21],
      [6, 21],
    ],
    cancer: [
      [6, 22],
      [7, 22],
    ],
    leo: [
      [7, 23],
      [8, 23],
    ],
    virgo: [
      [8, 24],
      [9, 23],
    ],
    libra: [
      [9, 24],
      [10, 23],
    ],
    scorpio: [
      [10, 24],
      [11, 22],
    ],
    sagittarius: [
      [11, 23],
      [12, 21],
    ],
    capricornus: [
      [12, 22],
      [1, 20],
    ],
  };

  const month = date.getMonth() + 1;
  const day = date.getDate();

  for (const [sign, dateRange] of Object.entries(zodiacDates)) {
    const [fromMonth, fromDay] = dateRange[0];
    const [toMonth, toDay] = dateRange[1];

    if ((month === fromMonth && day >= fromDay) || (month === toMonth && day <= toDay)) {
      return zodiacSigns[sign as keyof typeof zodiacSigns];
    }
  }

  throw new Error(`Invalid date for zodiac calculation: ${month}/${day}`);
}

export function getZodiacSignUrl(zodiacSign: string): string {
  const zodiacUrls: Record<string, string> = {
    Wassermann: '/themen/thema/sternzeichen-wassermann-t10219.html',
    Fisch: '/themen/thema/sternzeichen-fische-t10198.html',
    Widder: '/themen/thema/sternzeichen-widder-t10209.html',
    Stier: '/themen/thema/sternzeichen-stier-t10210.html',
    Zwilling: '/themen/thema/sternzeichen-zwillinge-t10211.html',
    Krebs: '/themen/thema/sternzeichen-krebs-t10212.html',
    Löwe: '/themen/thema/sternzeichen-loewe-t10213.htm',
    Jungfrau: '/themen/thema/sternzeichen-jungfrau-t10214.html',
    Waage: '/themen/thema/sternzeichen-waage-t10215.html',
    Skorpion: '/themen/thema/sternzeichen-skorpion-t10216.html',
    Schütze: '/themen/thema/sternzeichen-schuetze-t10217.html',
    Steinbock: '/themen/thema/sternzeichen-steinbock-t10218.html',
  };

  return zodiacUrls[zodiacSign] ?? '';
}
